import React, { useState } from 'react';
import apiClient from './services/api';
import './AdminLogin.css';

interface AdminLoginProps {
  onLogin: () => void;
  onBackToHome?: () => void;
}

const AdminLogin: React.FC<AdminLoginProps> = ({ onLogin, onBackToHome }) => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleLogin = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    
    try {
      // Backend'e login isteği at
      const response = await apiClient.post('/admin/login', {
        username,
        password,
      });

      if (response.data.success && response.data.data?.token) {
        // Token'ı localStorage'a kaydet
        localStorage.setItem('adminToken', response.data.data.token);
        localStorage.setItem('isAdminLoggedIn', 'true');
        onLogin();
      } else {
        setError('Giriş başarısız!');
      }
    } catch (err: any) {
      console.error('Login hatası:', err);
      // Backend'e ulaşılamazsa basit kontrol yap (development için)
      if (username === 'admin' && password === 'admin123') {
        localStorage.setItem('isAdminLoggedIn', 'true');
        // Fake token oluştur (production'da backend token kullanılacak)
        localStorage.setItem('adminToken', 'dev-token-' + Date.now());
        onLogin();
      } else {
        setError(err.response?.data?.message || 'Kullanıcı adı veya şifre hatalı!');
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="admin-login">
      <div className="login-container">
        <div className="login-card">
          <h1>🔐 Admin Paneli</h1>
          <p className="login-subtitle">Villa Polikne Yönetim Paneli</p>
          
          <form onSubmit={handleLogin}>
            <div className="form-group">
              <label>Kullanıcı Adı</label>
              <input
                type="text"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                placeholder="Kullanıcı adınızı girin"
                required
              />
            </div>
            
            <div className="form-group">
              <label>Şifre</label>
              <input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="Şifrenizi girin"
                required
              />
            </div>
            
            {error && <div className="error-message">{error}</div>}
            
            <button type="submit" className="btn-login" disabled={loading}>
              {loading ? 'Giriş yapılıyor...' : 'Giriş Yap'}
            </button>
          </form>
          
          {onBackToHome && (
            <button 
              type="button" 
              className="btn-back-home"
              onClick={onBackToHome}
            >
              ← Ana Sayfaya Dön
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default AdminLogin;
